<template>
  <div class="headerContainer">
    <div class="header">
      <img src="../assets/logo.png" class="logo" />
      <nav-bar></nav-bar>
    </div>
    <div class="m_header">
      <!-- <div class="logo"></div> -->
      <div class="title">嘉信保险经纪</div>
      <drop-down></drop-down>
    </div>
  </div>

</template>
<script>
import NavBar from "./NavBar";
import DropDown from "./DropDown";
export default {
  components: {
    DropDown,
    NavBar
  },
  name: 'headerTop',
}
</script>
<style scoped lang="less" src="../style/index.less"></style>



// WEBPACK FOOTER //
// src/components/Header.vue